<template>
  <div
    v-if="hasBanner"
    :key="deal.id"
    class="banner"
    :class="{'sold-out': isSoldOut,
             'coming-soon': isComingSoon,
             'is-ending': isEnding,
             'last-call': isLimitedTimeSale,
             'new-deal': isNewDeal,
    }"
  >
    <span
      v-if="isLimitedTimeSale"
      class="col-5 px-0"
    >
      <img
        src="@legacy/static/images/svg/as-plus-white.svg"
        width="126"
        height="12"
        class="img-fluid"
        alt="Plus white icon"
      >
    </span>
    <span
      class="banner-text"
      :class="{ 'limited-time-sale': isLimitedTimeSale }"
      data-testid="deal-banner-text"
    >{{ bannerText }}</span>
  </div>
</template>

<script>
import moment from 'dayjs'; // Drop in replacement for moment
import relativeTime from 'dayjs/plugin/relativeTime';

moment.extend(relativeTime);

export default {
  name: 'DealBanner',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    isBlackFridayLastCall: {
      type: Boolean,
      required: true,
    },
    isLastCall: {
      type: Boolean,
      required: true,
    },
    isLimitedTimeSale: {
      type: Boolean,
      required: true,
    },
    isNewDeal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const ret = {
      hasBanner: false,
      bannerText: '',
      isSoldOut: false,
      isComingSoon: false,
      isEnding: false,
    };

    if (this.deal.buy_button && this.deal.buy_button.is_coming_soon === true) {
      ret.hasBanner = true;
      ret.isComingSoon = true;
      ret.bannerText = 'Coming soon!';
    } else if (this.deal.browse_deal_status === 'expired') {
      ret.hasBanner = true;
      ret.isSoldOut = true;
      ret.bannerText = 'Sold out';
    } else if (this.isLimitedTimeSale) {
      ret.hasBanner = true;
      // jl: 72 hour sale applies to black friday's last call
      ret.bannerText = this.isLastCall ? '96 hour sale only' : '72 hour sale only';
    } else if (this.deal.shows_codes_remaining && this.deal.codes_remaining > 0) {
      ret.hasBanner = true;
      ret.bannerText = `Only ${this.deal.codes_remaining} remaining`;
    } else if (this.canShowTimer()) {
      ret.hasBanner = true;
      ret.bannerText = `Offer ends ${moment(this.deal.dates.end_date).fromNow()}`;
      ret.isEnding = true;
    } else if (this.isNewDeal) {
      ret.hasBanner = true;
      ret.bannerText = 'New!';
    }

    return ret;
  },
  mounted() {
    this.intervalId = null;
    if (this.isEnding && this.canShowTimer()) {
      this.generateTimerInterval();
    }
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods: {
    canShowTimer() {
      return this.deal.dates
          && this.deal.dates.end_date
          && this.deal.has_started
          && this.deal.active_timer
          && this.dealIsLive();
    },
    generateTimerInterval() {
      this.intervalId = setInterval(() => {
        if (this.dealIsLive()) {
          this.hasBanner = true;
          this.isEnding = true;
          this.bannerText = `Offer ends ${moment(this.deal.dates.end_date).fromNow()}`;
        } else {
          this.hasBanner = false;
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }, 30000);
    },
    dealIsLive() {
      return this.deal.browse_deal_status === 'current';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~/styles/dorado/main';

  .banner {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
    text-align: center;
    background-color: $money-moss;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.05em;
    line-height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner-text {
    padding: 5px 0;
    display: block;
  }

  .sold-out {
    background-color: #f64747;
  }

  .coming-soon {
    background-color: #0044c0;
  }

  .is-ending {
    background-color: #c22f0f;
  }

  .new-deal {
    background-color: #069a2f;
  }

  .limited-time-sale {
    border-radius: 25px;
    background-color: #1b1b1b;
    font-size: 12px;
    padding: 1px 6px;
  }

  .last-call {
    background-color: #ff5732;
    display: flex;
    justify-content: space-between;
    padding: 3px 8px;
  }
</style>
